import { Link, useLocation } from "react-router-dom";

import {
  GLOFOX_FLOW_SECTIONS,
  GLOFOX_OVERVIEW_LINKS,
} from "@/lib/portal/glofox-nav";

interface GlofoxSidebarNavProps {
  /** Optional prefix so drawer links do not collide with desktop sidebar test ids. */
  testIdPrefix?: string;
  onNavigate?: () => void;
}

export function GlofoxSidebarNav({
  testIdPrefix = "",
  onNavigate,
}: GlofoxSidebarNavProps) {
  const { pathname } = useLocation();

  return (
    <>
      <div className="sb-sect">Overview</div>
      {GLOFOX_OVERVIEW_LINKS.map((link) => (
        <Link
          key={link.href}
          to={link.href}
          data-testid={testIdPrefix ? `${testIdPrefix}-${link.testId}` : link.testId}
          className={`sb-link${pathname === link.href ? " active" : ""}`}
          aria-current={pathname === link.href ? "page" : undefined}
          onClick={onNavigate}
        >
          <i className={`ti ${link.icon}`} aria-hidden />
          {link.label}
        </Link>
      ))}

      <div className="sb-sect">Flows</div>
      {GLOFOX_FLOW_SECTIONS.map((section) => (
        <div key={section.title}>
          <div className="sb-sect sb-sect-sub">{section.title}</div>
          {section.items.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              data-testid={
                testIdPrefix ? `${testIdPrefix}-${link.testId}` : link.testId
              }
              className={`sb-link${pathname === link.href ? " active" : ""}`}
              aria-current={pathname === link.href ? "page" : undefined}
              onClick={onNavigate}
            >
              <i className={`ti ${link.icon}`} aria-hidden />
              {link.label}
            </Link>
          ))}
        </div>
      ))}
    </>
  );
}
